import { Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';
import { APPLICATION_STATUS } from '../../../../../constants/event-application-status';
import { setEvent } from '../../../../../core/events/action';
import ApplicationCard from './ApplicationCard';

function VendorApplications({ event }) {
  const dispatch = useDispatch();

  const vendorEvents = useMemo(
    () =>
      event?.vendorEvents?.length > 0
        ? event.vendorEvents.filter((ve) => ve.application_status === APPLICATION_STATUS.PENDING)
        : [],
    [event],
  );

  const removeVendorEventByIds = (vendorEventData) => {
    const { fk_vendor: vendorId, fk_event: eventId } = vendorEventData;
    const newVendorEvents = event.vendorEvents.filter(
      (ve) => !(ve.fk_vendor === vendorId && ve.fk_event === eventId),
    );
    const newEvent = { ...event, vendorEvents: newVendorEvents };

    dispatch(setEvent(newEvent));
  };

  return (
    <Paper sx={{ backgroundColor: '#FCE5DD', p: 3, mb: 2 }}>
      {vendorEvents.length > 0 ? (
        vendorEvents.map((ve) => (
          <ApplicationCard
            key={uuidv4()}
            vendorEvent={ve}
            onStatusChanged={removeVendorEventByIds}
          />
        ))
      ) : (
        <Typography fontWeight="bold">No new applications</Typography>
      )}
    </Paper>
  );
}

VendorApplications.propTypes = {
  event: PropTypes.instanceOf(Object).isRequired,
};

export default VendorApplications;
